// Queries
import pastDueInvoiceInfo from "./PastDueInvoiceInfoQuery.gql";

// Mutations
import addDeliveryRequest from "./AddDeliveryRequestMutation.gql";

export const Query = {
    pastDueInvoiceInfo,
};

export const Mutation = {
    addDeliveryRequest,
};
